import { makeStyles } from 'makeStyles';
import {
  BLUE_BACKGROUND_WRAPPER,
  BLUE_BACKGROUND_WRAPPER_BORDER,
  MAIN,
  NOTIFICATION_ORANGE,
  TEXT_GREEN,
} from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  divider: {
    height: '20px',
    width: '100%',
  },
  scheduleTableConfig: {
    boxShadow: 'none',
    '& > div': {
      minWidth: 1000,
    },
  },
  scheduleCellConfig: {
    padding: 5,
  },
  scheduleTableIndexCell: {
    borderBottom: 'none',
    width: '30px',
  },
  scheduleTableTimeCell: {
    minWidth: '100px',
  },
  scheduleTableDrawCell: {
    minWidth: '130px',
  },
  scheduleTableEventCell: {
    minWidth: '150px',
  },
  scheduleTableDragHandleCell: {
    fontSize: '10px',
    padding: 0,
    width: '40px!important',
  },
  courtTitle: {
    borderLeft: 'none',
    borderRight: 'none',
    height: '57px',
    minWidth: '194px',
    maxWidth: '194px',
    width: '194px',
    textAlign: 'center',
    '& > div': {
      width: '100%',
    },
  },
  firstColumnCourtsTable: {
    minWidth: '120px',
    width: '120px',
    height: '57px!important',
    '& > div': {
      height: '47px',
      padding: 5,
      width: '100%',
    },
  },
  scheduleTableCellNoWrap: {
    whiteSpace: 'nowrap',
    width: '5%',
  },
  scheduleTableCellSides: {
    width: '20%',
  },
  scheduleTableCellWinningSide: {
    color: TEXT_GREEN,
    fontWeight: 'bold',
  },
  scoreCell: {
    minWidth: 150,
    width: '15%',
  },
  setupContainer: {
    margin: '0 0 20px',
    padding: 30,
    borderRadius: 4,
    border: 'solid 1px rgba(221, 157, 59, 0.3)',
    backgroundColor: '#fffbed',
  },
  buttonContainer: {
    marginTop: 15,
  },
  setupItem: {
    fontSize: 13,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.4,
    letterSpacing: 0.26,
    textAlign: 'left',
    color: '#737680',
  },
  setupItemCurrent: {
    fontWeight: 900,
    color: '#3e424e',
  },
  setupItemSettledUp: {
    color: '#3e424e',
    textDecoration: 'line-through',
  },
  icon: {
    marginRight: 8,
  },
  headerContainer: {
    margin: '0 0 20px 0',
  },
  paper: {
    padding: '15px 25px',
    position: 'relative',
  },
  publishEditWrapper: {
    display: 'flex',
    gap: 15,
    position: 'absolute',
    right: 23,
    top: 18,
    zIndex: 5,
  },
  publishTooltipIcon: {
    padding: 0,
  },
  whiteButton: {
    backgroundColor: theme.palette.common.white,
  },
  disabledDragHandle: {
    color: theme.palette.grey[300],
  },
  activeFacilitiesButton: {
    height: '100%',
    width: '100%',
    '&.MuiButtonBase-root': {
      padding: 0,
    },
  },
  tableSubheader2: {
    marginTop: 20,
    minHeight: 50,
  },
  selectedTypography: {
    fontWeight: 600,
  },
  checkboxColumn: {
    width: 40,
  },
  subtitleGreyText: {
    color: theme.palette.grey[100],
    fontSize: 14,
  },
  sendSmsWrapper: {
    background: BLUE_BACKGROUND_WRAPPER,
    border: `1px solid ${BLUE_BACKGROUND_WRAPPER_BORDER}`,
    height: 50,
    padding: 10,
  },
  sendSmsSubWrapperContainer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  matchCounterText: {
    fontSize: 14,
    fontWeight: 600,
  },
  tabs: {
    marginTop: 10,
    '& p': {
      fontSize: 15,
    },
  },
  tab: {
    textAlign: 'left',
    textTransform: 'initial',
    width: '100%',
  },
  selectedTab: {
    '& .MuiTypography-root': {
      color: MAIN,
    },
  },
  tabCompleted: {
    display: 'flex',
  },
  bulkIconGridItem: {
    height: 24,
    marginTop: 2,
  },
  tabPanel: {
    '& > div': {
      paddingTop: 10,
    },
  },
  filtersWrapper: {
    marginTop: 10,
  },
  eventsSelector: {
    minWidth: '285px',
  },
  defaultSelectorWidth: {
    minWidth: '150px',
  },
  searchIcon: {
    marginRight: 0,
    width: 30,
  },
  scoreFormatsSelector: {
    minWidth: '250px',
  },
  assignCourtCell: {
    marginRight: '35px',
    maxWidth: 'unset!important',
  },
  tooltipTitle: {
    fontWeight: 600,
    marginBottom: 10,
  },
  tooltipContent: {
    fontSize: 14,
  },
  awaitingResultTableTypography: {
    backgroundColor: NOTIFICATION_ORANGE,
    borderRadius: 3,
    padding: '3px 6px 3px 6px',
    width: 'fit-content',
    lineHeight: 1.3,
    '& > p': {
      color: theme.palette.common.white,
      fontSize: 13,
      lineHeight: 1.4,
      fontWeight: 900,
    },
  },
  completedBadge: {
    backgroundColor: NOTIFICATION_ORANGE,
    borderRadius: '50%',
    height: 20,
    marginLeft: 10,
    width: 20,
    '& > p': {
      color: theme.palette.common.white,
      fontSize: 13,
      fontWeight: 900,
      lineHeight: 1.6,
      width: 20,
      textAlign: 'center',
    },
  },
  buttonIcon: {
    height: '16px',
    marginRight: theme.spacing(1),
    stroke: '#427fc0',
    width: 'auto',
    '&:svg': {
      width: 16,
      height: 16,
      '&:path': {
        color: 'white',
        fill: 'white',
        stroke: 'white',
      },
    },
  },
  buttonIconRight: {
    marginRight: 0,
    marginLeft: theme.spacing(1),
  },
  schedulingButton: {
    backgroundColor: 'white',
    stroke: '#427fc0',
    '& svg': {
      '& path': {
        stroke: '#427fc0',
      },
    },
  },
  matchScheduleHeader: {
    display: 'flex',
  },
  infoIcon: {
    width: 20,
    height: 20,
    cursor: 'pointer',
  },
  emptyMessage: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#737680',
  },
  eventNameCell: {
    fontWeight: '400',
  },
}));
